import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import { Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faListCheck,
  faServer,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons';
export interface MenuItem {
  label: string;
  icon: React.ReactElement;
  subMenu?: SubMenuItem[];
  submenuitems: string[];
  to?: string;
  route: string;
  id?: string;
  activeMenuIcon: React.ReactElement;
}

interface SubMenuItem {
  label: string;
  menu: string;
  permissionname: string;
  icon: (isActive: boolean) => React.ReactElement;
  to: string;
  id?: string;
}

interface Pagepermission {
  pagepermission: MenuItem[];
  collapseView: boolean;
}

export const menuItems: MenuItem[] = [
  {
    label: 'Equipment',
    route: 'equipment',
    to: '/equipment/ownedequipment',
    id: 'equipment',
    icon: <FontAwesomeIcon icon={faServer} className="sidebaricons" />,
    activeMenuIcon: <FontAwesomeIcon icon={faServer} className="activeicons" />,
    submenuitems: ['equipment'],
    subMenu: [
      {
        label: 'My Equipment',
        menu: 'euqipment',
        to: '/equipment/ownedequipment',
        permissionname: 'equipment',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faServer}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'Shared with me',
        menu: 'euqipment',
        to: '/equipment/sharedwithmeequipment',
        permissionname: 'equipment',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faServer}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
    ],
  },
  {
    label: 'Audit Log',
    route: 'auditlog',
    to: '/auditlogupdate',
    id: 'equipment',
    icon: <FontAwesomeIcon icon={faUserShield} className="sidebaricons" />,
    activeMenuIcon: (
      <FontAwesomeIcon icon={faUserShield} className="activeicons" />
    ),
    submenuitems: [],
  },
  {
    label: 'Billing',
    route: 'billing',
    to: '/manageBilling',
    id: 'equipment',
    icon: <FontAwesomeIcon icon={faListCheck} className="sidebaricons" />,
    activeMenuIcon: (
      <FontAwesomeIcon icon={faListCheck} className="activeicons" />
    ),
    submenuitems: [],
  },
];

const NestedList: React.FC<Pagepermission> = ({
  pagepermission,
  collapseView,
}) => {
  const [allowPages, setAllowPages] = useState<MenuItem[]>([]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [pagename, setPageName] = useState('/dashboard');
  const location = useLocation();

  useEffect(() => {
    const pageName = location.pathname.split('/')[1];
    setPageName(pageName);
    const checkindex = menuItems.findIndex((a) => {
      return location.pathname.split('/')[1] === a.route;
    });

    setOpenIndex(checkindex >= 0 ? checkindex : null);
  }, [location.pathname]);

  const handleClick = (index: number) => {
    setOpenIndex((prevOpenIndex) => (prevOpenIndex === index ? null : index));
  };

  const isMenuItemActive = (type: string, to?: string) => {
    if (type === 'menu') {
      return pagename === to?.split('/')[1];
    } else {
      if (to === '/equipment/sharedwithmeequipment') {
        return location.pathname.startsWith('/equipment/sharedwithmeequipment');
      } else if (to === '/equipment/ownedequipment') {
        return location.pathname.startsWith('/equipment/ownedequipment');
      } else {
        return location.pathname === to;
      }
    }
  };

  useEffect(() => {
    setAllowPages(pagepermission);
  }, [pagepermission.length > 0]);

  return (
    <List className="sidebar_list" component="nav">
      {allowPages?.length > 0 &&
        allowPages.map((menuItem: MenuItem, index: number) => (
          <React.Fragment key={index}>
            <Tooltip
              title={menuItem.label}
              placement="right"
              disableHoverListener={!collapseView}
            >
              <ListItemButton
                onClick={() => handleClick(index)}
                component={menuItem.to ? RouterLink : 'div'}
                to={menuItem.to}
                className={`${collapseView && 'collapseView_ListItemButton'} sidebar_list_menubtn`}
              >
                <ListItemIcon>
                  {isMenuItemActive('menu', menuItem.to)
                    ? menuItem.activeMenuIcon
                    : menuItem.icon}
                </ListItemIcon>
                {!collapseView && (
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        className={`${isMenuItemActive('menu', menuItem.to) ? 'menu_item-active' : 'menu_item'}`}
                      >
                        {menuItem.label}
                      </Typography>
                    }
                  />
                )}
              </ListItemButton>
            </Tooltip>
            <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItem.subMenu?.map(
                  (subMenuItem: SubMenuItem, subIndex: number) => (
                    <Tooltip
                      key={subIndex}
                      title={subMenuItem.label}
                      placement="right"
                      disableHoverListener={!collapseView}
                    >
                      <ListItemButton
                        className={`ListItemButton ${collapseView && 'collapseView_ListItemButton'}`}
                        key={subIndex}
                        component={RouterLink}
                        to={subMenuItem.to}
                        onClick={() => {
                          setPageName(subMenuItem.to);
                        }}
                      >
                        <ListItemIcon>
                          {subMenuItem.icon(
                            isMenuItemActive('submenu', subMenuItem.to),
                          )}
                        </ListItemIcon>
                        {!collapseView && (
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                className={`${isMenuItemActive('submenu', subMenuItem.to) ? 'menu_item-active' : 'menu_item'}`}
                              >
                                {subMenuItem.label}
                              </Typography>
                            }
                          />
                        )}
                      </ListItemButton>
                    </Tooltip>
                  ),
                )}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
    </List>
  );
};

export default NestedList;
